// FIXME: Instead of using a fixed width, we should use grid layout to make the settings items more flexible but this
// requires some design changes to the designer settings panel first.
export const SETTINGS_ITEM_WIDTH = "w-[110px]";
